(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6418],{

/***/ 40674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/ebay-freight-spring-2022/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-04-29",
      tag: "eBay",
      title: "Guide to eBay Freight Shipping 2022",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["eBay freight shipping is a hot topic for many sellers. It can be hard to know where to start and what type of service will work best for you with so much information. Freight shipping can be confusing for sellers because there are so many different ways to ship your items.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This article aims to get you familiarized with the best shipping option so you can offer free or low-cost shipping to your buyers. We will also discuss the difference between flat rate and freight rate tables, what they are, how they work, and other shipping services you can try for your growing business\u2013 let's get started!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What is eBay Freight Shipping? "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Aside from small package carriers like USPS, UPS, and FedEx, eBay also offers an economical alternative in delivering your large item to your buyer's doorstep\u2013 these are called freight carriers.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Freight carriers let you ship bigger or heavier items such as appliances, furniture, gym equipment, and other bulky items. If you have one of these items that you want to sell or de-clutter, you might want to consider listing and shipping with freight carriers.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Flat-rate freight vs Freight rate tables "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["eBay sellers have two ways to offer their buyers freight shipping options: ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Flat-rate freight"
        }), ' ', "and ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "freight rate tables"
        }), ". Both options offer an economical way of shipping your oversized items to your buyers, so they can purchase them without worrying about paying an excessive shipping fee.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This section will explain the difference between flat rates and freight rate tables and why some people might choose one over the other."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "Flat-Rate Freight"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["A flat-rate freight shipping option provides a straightforward shipping cost you can offer to all your U.S. buyers regardless of their location or the states they are residing in. This means sellers will provide a flat shipping rate no matter how heavy or how far their delivery addresses are.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "When to use it:"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["You may use this type of freight carrier if you want to charge a single shipping cost to all your buyers within the U.S. You can also choose this freight carrier if you're offering free shipping to your U.S. domestic buyers.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["This is ideal if most of your buyers are located in nearby areas or states. You can also encourage buyers to spend more by buying more items using flat-rate freight since the fee will be fixed, regardless of the dimension and weight of the items.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "How to List"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "To list your product with flat-rate freight, simply follow these steps: "
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "On the listing page, click the \"Shipping Details\" section "
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Click the drop-down button and choose Flat: Same cost to all buyers"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Choose flat-rate freight as your \"service.\""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Pick a single shipping cost that will be displayed to all your domestic buyers "
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Add your package type, weight, and dimension. "
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "Freight-Rate Table"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["A freight-rate table option provides a wide range of shipping fees based on up to 100 buyer regions within the U.S. You can use this table to easily provide shipping costs by region that you can pass to your buyers.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "After creating your freight-rate table, you can apply it within your listing flow to quickly identify the shipping cost depending on your buyer's region. You can also save the freight-rate table for your future use."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "When to Use It:"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["You may use this type of freight carrier if you want to charge different freight shipping costs based on your buyers' location. You may still offer free shipping to buyers in certain states or may offer varying shipping costs for freight delivery.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["This is ideal primarily if you cater to many buyers in different regions. Having a freight table can also save you time and money since you can apply it within your listing.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "How to Create Freight-Rate Tables"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Creating your freight table is easy. Simply follow these five easy steps: "
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "On the listing page, click the \"Shipping Details\" section "
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Click the \"Freight Shipping Item\" field and select the package type "
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Enter a name for your freight-rate table by clicking \"Table Name.\" "
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Enter the shipping cost you'll charge your buyers for each region. "
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Click on \"Save\" to save your newly created freight rate table. "
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Other Shipping Carriers Integrated with eBay "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Aside from the freight carriers, eBay also has other shipping carriers that you can consider as your shipping option. Take a moment to consider other shipping carriers available. Depending on your needs, it might be worth your while to look into how each option works and choose the best service that will work for you.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The following are other domestic shipping services you can provide to your buyers within the U.S.: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "USPS"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["USPS offers a simple and efficient way to ship your items to your buyers. They offer free scheduled pickups, or you can also drop them off at the nearest post office in your area. USPS also provides free flat-rate supplies for Priority Mail and Priority Mail Express, and you can get up to 30% off on retail rates if you are using eBay labels.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["You can use USPS First-class package for packages under 1lb and Priority Mail for parcels under 5 lbs. This is ideal for selling small or light items as USPS offers competitive pricing for shipped items below 5lb and 1lb.", ' ']
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "FedEx "
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["FedEx offers competitive and reliable shipping services for your packages using eBay labels. They offer a flat rate 2-day air pricing with a slower shipping alternative for packages under 10lbs. Their residential delivery is available seven days a week\u2013 including Sundays.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["Furthermore, FedEx has one of the best-in-class commercial and residential delivery rates. Unlike USPS, FedEx does not offer free residential pickup, but you can drop it off at over 50,000+ FedEx drop-off locations, including some participating Walgreens and Dollar General stores.", ' ']
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "UPS "
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["UPS is one of the most popular and has a well-established customer reputation based on its reliability, trust, and choice. Customers can enjoy up to two days faster delivery at no extra cost, and they also offer six days of delivery per week, including Saturdays, to lessen customers' waiting time.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["Additionally, UPS offers discounts on their shipping rates of up to 50% on UPS Ground shipments and up to 66% for UPS 2nd Day Air service and UPS Next Day Delivery service. UPS does not offer free residential pickups, but you can have your parcel dropped off at over 85,000 locations, including UPS Stores, UPS Drop Boxes, and Access Point locations.", ' ']
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "eBay Standard Envelope"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["Shipping your small items under 3 oz is much cheaper and more secure if you use the eBay Standard envelope. This shipping service option is ideal for categories under collectibles such as trading cards, coins and currency, postcards, and stamps under 3 oz.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["You can also save up to 70% compared to using USPS First class package service, and the integrated tracking makes it easier to print and ship using eBay labels. Their shipping protection plan can be up to $50 on combined items in case of loss or damages. Unfortunately, this type of shipping service does not have residential pickups. But you can drop it off at regular USPS locations, requiring no acceptance scan.", ' ']
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Build Customer Trust"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "After learning how eBay freight shipping works and other shipping services integrated into eBay, let's work on building your customer's trust and increasing your sales."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Your customer's buying journey does not end after you ship their items. You must still keep track of your item's delivery until it reaches your customers. Remember to always upload the tracking number and tag the correct freight carrier no matter what shipping service option you choose. This will help your buyers track their items quickly and lessen questions about the delivery status and \"Item Not Received\" claims.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Another helpful way to build customers' trust and save you more time doing other things like scheduling package pickups or ordering shipping supplies for your business is by having an all-in-one automation app like OneShop.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["OneShop offers features beyond automation, ideal for busy resellers like you. It not only automates marketplace activities for you, but it also allows you to easily create drafts and cross-list them to other marketplaces to increase your sales and boost your exposure.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Plus, you no longer have to worry about selling a single product on different platforms as OneShop also has a delisting feature that automatically delists once you sell.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/signup",
          children: "Sign-up to OneShop today"
        }), " and take advantage of its 7-day free trial with no outright payment needed. Let this innovative automation service help you have more time in your hands to focus more on growing your business or enjoying life stuff.", ' ']
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/ebay-freight-spring-2022.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Guide to eBay Freight Shipping 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Learn how eBay freight shipping works and see what type of shipping will work best for you"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/ebay-freight-spring-2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/ebay-freight-spring-2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Guide to eBay Freight Shipping 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Learn how eBay freight shipping works and see what type of shipping will work best for you"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=3"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-04-29T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-04-29T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "eBay"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 3906:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/ebay-freight-spring-2022",
      function () {
        return __webpack_require__(40674);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(3906); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);